import React from 'react';

const PorscheBadge = (props) => (
  <img
    {...props}
    alt="Porsche® x Backdrop"
    src="https://cdn.shopify.com/s/files/1/0051/6295/8946/files/porsche-collab-badge.png?v=1688044279"
  />
);

export default PorscheBadge;
